import { render, staticRenderFns } from "./SelectComp.vue?vue&type=template&id=6c345d92&scoped=true&"
import script from "./SelectComp.vue?vue&type=script&lang=js&"
export * from "./SelectComp.vue?vue&type=script&lang=js&"
import style0 from "./SelectComp.vue?vue&type=style&index=0&id=6c345d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c345d92",
  null
  
)

export default component.exports